class CollectionGridView {
  constructor() {
    this.gridContainer = document.querySelector('#product-grid');
    this.detailedGridBtn = document.querySelector('.grid-view-btn.detailed-grid');
    this.simpleGridBtn = document.querySelector('.grid-view-btn.simple-grid');
    this.mobileGridBtn = document.querySelector('.grid-view-mobile');
    
    // Initialize view from localStorage
    this.currentView = localStorage.getItem('gridView') || 'detailed';
    
    this.init();
  }

  init() {
    // Set initial view
    this.setGridView(this.currentView);
    
    // Add click handlers
    this.detailedGridBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      this.setGridView('detailed');
    });
    
    this.simpleGridBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      this.setGridView('simple');
    });
    
    // Add mobile button click handler
    this.mobileGridBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      const currentView = localStorage.getItem('gridView') || 'detailed';
      this.setGridView(currentView === 'detailed' ? 'simple' : 'detailed');
    });
  }

  setGridView(view) {
    if (view === 'simple') {
      // Remove detailed view classes
      this.gridContainer.classList.remove('small-up-2', 'medium-up-3');
      // Add simple view classes
      this.gridContainer.classList.add('small-up-3', 'medium-up-5');
      // Toggle button states
      this.simpleGridBtn.classList.add('active');
      this.detailedGridBtn.classList.remove('active');
      
      // Update mobile button
      if (this.mobileGridBtn) {
        const viewIcon = this.mobileGridBtn.querySelector('.current-view-icon');
        const viewText = this.mobileGridBtn.querySelector('.view-text');
        const simpleGridSvg = document.getElementById('simple-grid-svg');
        
        if (viewIcon && simpleGridSvg) {
          viewIcon.innerHTML = simpleGridSvg.outerHTML;
        }
        if (viewText) {
          viewText.textContent = 'View';
        }
      }
    } else {
      // Remove simple view classes
      this.gridContainer.classList.remove('small-up-3', 'medium-up-5');
      // Add detailed view classes
      this.gridContainer.classList.add('small-up-2', 'medium-up-3');
      // Toggle button states
      this.detailedGridBtn.classList.add('active');
      this.simpleGridBtn.classList.remove('active');
      
      // Update mobile button
      if (this.mobileGridBtn) {
        const viewIcon = this.mobileGridBtn.querySelector('.current-view-icon');
        const viewText = this.mobileGridBtn.querySelector('.view-text');
        const detailedGridSvg = document.getElementById('detailed-grid-svg');
        
        if (viewIcon && detailedGridSvg) {
          viewIcon.innerHTML = detailedGridSvg.outerHTML;
        }
        if (viewText) {
          viewText.textContent = 'View';
        }
      }
    }
    
    // Store the view preference
    localStorage.setItem('gridView', view);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CollectionGridView();
});